// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1Tqf8","tab":"Tabs_tab__FaRsp","tabActive":"Tabs_tabActive__3quxM"};